import { useNavigate } from "react-router-dom";

import { useCreateOwnerEntity } from "pages/PitPort/OwnerEntity/api";
import BaseOwnerEntityForm from "pages/PitPort/OwnerEntity/BaseOwnerEntityForm";

const CreateOwnerEntity = () => {
  const navigate = useNavigate();
  const { create } = useCreateOwnerEntity();

  const handleSubmit = async (data: {
    name: string;
    address: string;
    tel: string;
    email: string;
    type: PitPortOwnerEntityType;
    profitShareRate: number;
  }) => {
    return await create(data);
  };

  return (
    <BaseOwnerEntityForm
      mode="create"
      onSubmit={handleSubmit}
      onCancel={() => navigate("/pit_port/owner-entities")}
      breadcrumbItems={[{ pageName: "貸主", onClick: () => navigate("/pit_port/owner-entities") }]}
      currentPageName="貸主を追加"
    />
  );
};

export default CreateOwnerEntity;
